import useFetchMinDepositAmount from "./useFetchMinDepositAmount"

export default function useInitDataFromSdk() {
  useFetchMinDepositAmount()
}
